"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("@ant-design/icons/lib/components/Icon");
var SvgDownFilledSvg = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "down-filled_svg__icon", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M5.626 8.045c-.206.109-.48.388-.588.599a.8.8 0 0 0 .001.719c.125.25 6.348 6.473 6.598 6.598a.8.8 0 0 0 .726 0c.25-.125 6.473-6.348 6.598-6.598.176-.353.086-.718-.26-1.064-.34-.34-.721-.431-1.073-.255-.112.056-1.07.985-2.898 2.809L12 13.579l-2.73-2.726C7.442 9.029 6.484 8.1 6.372 8.044a.88.88 0 0 0-.746.001" }))); };
var SvgDownFilled = function (props) { return (React.createElement(Icon_1.default, __assign({ component: SvgDownFilledSvg }, props))); };
exports.default = SvgDownFilled;
